export default "__VITE_PUBLIC_ASSET__b025b090__"